/**
 * Safely removes a DOM node from its parent.
 * This prevents NotFoundError when removeChild is called on a node that is not a child.
 * 
 * @param {Node} node - The DOM node to remove
 * @param {Node} [parent] - Optional parent node. If provided, only removes if node is actually a child of parent.
 * @returns {boolean} - Returns true if node was removed, false otherwise
 */
export function safeRemoveNode(node, parent) {
  if (!node) return false;
  
  // If parent is specified, verify the node is actually a child before removing
  if (parent) {
    if (!node.parentNode || node.parentNode !== parent) {
      return false;
    }
    try {
      parent.removeChild(node);
      return true;
    } catch (error) {
      // Fallback to node.remove() if removeChild fails
      if (error.name === 'NotFoundError') {
        try {
          node.remove();
          return true;
        } catch {
          return false;
        }
      }
      return false;
    }
  }
  
  // No parent specified - use modern remove() method which is safer
  try {
    node.remove();
    return true;
  } catch {
    return false;
  }
}

